export default {
    BASE_URL: '//scm-api.fthdaily.in',
    APP_URL: '//app-api.fthdaily.in',  
  };
  